import { Project } from '@thive/fddm-types';
import { useCallback } from 'react';

import { useAppMetaStore } from '@/modules/floorplanV2/store/project/projectState';

export const useLoadProjectV2 = () => {
  const load = useCallback((project: Project) => {
    useAppMetaStore.getState().setActiveProject(project);
  }, []);

  return {
    load,
  };
};
